// ABOUTME: Keycloak role that unlocks the PIM agents (the server checks it on every /api/agents route).
// ABOUTME: Gates the agent-tasks routes and the navigation entry.

export const PIM_AGENT_USER_ROLE = 'PIM_AGENT_USER';
